import React, { Component, Fragment } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import { Container, Row, Col, Button, Input, Form, FormGroup } from 'reactstrap';
import CollapseCard from '../CollapseCard/CollapseCard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faStop, faPlus, faEllipsisH, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';
import ConfirmButton from '../Modal/ConfirmButton';
// import PermissionWrapper from '../../auth/PermissionWrapper';
class Widget extends Component {

    constructor(props) {
        super(props);

        // this.props.employeeClient.map

        this.state = {
            times: [],
            activeButton: ''
        }

    }

    resetActiveButton = () => {
        this.props.log('Widget.js/resetActiveButton');
        this.setState({
            //activeButton: ''
        })
    }

    onStart = (obj) => {
        this.props.log('Widget.js/onHandleAdd (obj)', obj);
        this.setState({
            activeButton: 'start_0_' + obj.clientId + '_' + obj.workflowId + '_' + obj.clientTaskId
        }, () => {
            fetch('/api/clientTaskTimeTracking/', {
                method: 'POST',
                body: JSON.stringify({
                    clientId: obj.clientId,
                    workflowId: obj.workflowId,
                    clientTaskId: obj.clientTaskId,
                    date: this.getTZdate(),
                    beginTimestamp: this.getTZtime(),
                    endTimestamp: "",
                    duration: "",
                    notes: "",
                    employeeId: this.props.userEmployee.employeeId,
                    userAuth0: this.props.user,
                    isComplete: false
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success && results.data > 0) {
                        this.props.refreshUser(this.resetActiveButton);
                        this.props.addToast('Time entry added successfully.', 5, 'success')
                    } else {
                        this.props.addToast('Unable to add time entry.', 5, 'danger')
                        this.resetActiveButton();
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                    this.resetActiveButton();
                })
        })
    }

    onEnd = (obj) => {
        this.props.log('Widget.js/onEnd (obj,id)', obj, obj.id);
        this.setState({
            activeButton: 'end_0_' + obj.clientId + '_' + obj.workflowId + '_' + obj.clientTaskId
        }, () => {
            fetch('/api/clientTaskTimeTracking/' + obj.id, {
                method: 'PUT',
                body: JSON.stringify({
                    clientId: obj.clientId,
                    workflowId: obj.workflowId,
                    clientTaskId: obj.workflowTaskId,
                    date: this.getTZdate(),
                    beginTimestamp: obj.beginTimestamp,
                    endTimestamp: this.getTZtime(),
                    duration: this.calculateDuration(obj.beginTimestamp, this.getTZtime()),
                    notes: "",
                    employeeId: this.props.userEmployee.employeeId,
                    userAuth0: this.props.user,
                    isComplete: false
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        this.props.refreshUser(this.resetActiveButton);
                        this.props.addToast('Time entry updated successfully.', 5, 'success')
                    } else {
                        this.props.addToast('Unable to update time entry.', 5, 'danger')
                        this.resetActiveButton();
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                    this.resetActiveButton();
                })
        })
    }

    onComplete = (id) => {
        this.props.log('Widget.js/onComplete (id)', id);
        this.setState({
            activeButton: 'complete_' + id
        }, () => {
            fetch('/api/clientTaskTimeTrackingCompleted/' + id, {
                method: 'PUT',
                body: JSON.stringify({
                    isComplete: true
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        this.props.refreshUser(this.resetActiveButton);
                        this.props.addToast('Time entry completed successfully.', 5, 'success')
                    } else {
                        this.props.addToast('Unable to complete time entry.', 5, 'danger')
                        this.resetActiveButton();
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                    this.resetActiveButton();
                })
        })
    }

    onDelete = (id) => {
        this.props.log('Widget.js/onDelete (id)', id);
        this.setState({
            activeButton: 'delete_' + id
        }, () => {
            fetch('/api/clientTaskTimeTracking/' + id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                }
            })
                .then(results => results.json())
                .then(results => {
                    if (results.success) {
                        this.props.refreshUser(this.resetActiveButton);
                        this.props.addToast('Time entry deleted successfully.', 5, 'success')
                    } else {
                        this.props.addToast('Unable to delete time entry.', 5, 'danger')
                    }
                })
                .catch(() => {
                    this.props.addToast('An error has occurred.', 5, 'danger');
                })
        })
    }

    getTime = (time) => {
        this.props.log('Widget.js/getTime (time)', time);
        if (time == null || time === '') return '';
        var hours = parseInt(time.substring(0, 2)),
            minutes = parseInt(time.substring(3, 5)),
            ampm = 'am';
        if (hours === 12) {
            ampm = 'pm';
        } else if (hours === 0) {
            hours = 12;
        } else if (hours > 12) {
            hours -= 12;
            ampm = 'pm';
        }
        return hours + ':' + String(minutes).padStart(2, '0') + ' ' + ampm;
    }

    calculateDuration = (beginTimestamp, endTimestamp) => {
        this.props.log('Widget.js/calculateDuration (beginTimestamp,endTimestamp)', beginTimestamp, endTimestamp);
        if (beginTimestamp !== '' && endTimestamp !== '') {
            const [beginHours, beginMinutes] = beginTimestamp.split(':').map(item => parseInt(item));
            const [endHours, endMinutes] = endTimestamp.split(':').map(item => parseInt(item));
            return Math.max(((((endHours * 60) + endMinutes) - ((beginHours * 60) + beginMinutes)) / 60), 0).toFixed(2);
        } else {
            return '';
        }
    }

    getTZdate = () => {
        var date = new Date();
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
    }

    getTZtime = () => {
        var date = new Date();
        console.log(new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(11, 16))
        return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().substring(11, 16);
    }

    onChange = (obj) => {
        this.props.log('Widget.js/onChange (obj)', obj);
        this.props.handleChangeUserEmployee({
            clientId: obj.clientId,
            workflowId: obj.workflowId,
            clientTaskId: obj.clientTaskId,
            clientTaskTimeTrackingId: obj.clientTaskTimeTrackingId,
            beginTimestamp: obj.beginTimestamp,
            endTimestamp: obj.endTimestamp
        })
        fetch('/api/clientTaskTimeTracking/' + obj.clientTaskTimeTrackingId, {
            method: 'PUT',
            body: JSON.stringify({
                clientId: obj.clientId,
                workflowId: obj.workflowId,
                clientTaskId: null,
                date: this.getTZdate(),
                beginTimestamp: obj.beginTimestamp,
                endTimestamp: obj.endTimestamp,
                duration: this.calculateDuration(obj.beginTimestamp, obj.endTimestamp),
                notes: "",
                employeeId: this.props.userEmployee.employeeId,
                userAuth0: this.props.user,
                isComplete: obj.isComplete != null ? obj.isComplete : false
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.refreshUser();
                    this.props.addToast('Time entry updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update time entry.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFieldValue = (type, timestamp, trackingId, clientIndex, workflowIndex, workflowTaskIndex, ttIndex) => {
        console.log('log', type, timestamp, trackingId, clientIndex, workflowIndex, workflowTaskIndex, ttIndex);
        let times = [...this.state.times];
        if (times.findIndex(item => item.type === type
            && item.timestamp === timestamp
            && item.trackingId === trackingId
            && item.clientIndex === clientIndex
            && item.workflowIndex === workflowIndex
            && item.workflowTaskIndex === workflowTaskIndex
            && item.ttIndex === ttIndex) === -1) {
            times.push({
                type: type,
                timestamp: timestamp,
                trackingId: trackingId,
                clientIndex: clientIndex,
                workflowIndex: workflowIndex,
                workflowTaskIndex: workflowTaskIndex,
                ttIndex: ttIndex,
                value: null,
                saved: false
            })
            this.setState({
                times: times
            })
        }
        return "12:00";
    }

    render() {
        this.props.info('Widget.js/render');
        return (
            <Row>
                <Col md={12}>
                    <CollapseCard title={this.props.title} open={true}>
                        <Container>
                            <Row className='font-weight-bold'>
                                <Col md={2}>
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col className='text-left'>
                                                    Client
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={10}>
                                    <Row>
                                        <Col md={4}>
                                            <Row>
                                                <Col className='text-left'>
                                                    Workflow / Task
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md={8} className="text-center">
                                            <Row>
                                                <Col md={8}>
                                                    Start Time - End Time
                                                </Col>
                                                <Col md={4} className="text-left">
                                                    Actions
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            {this.props.employeeClient != null && this.props.employeeClient/*.filter(client => client.workflows != null)*/.map((client, clientIndex) => (
                                <Row key={client.clientId} className="mainRow">
                                    <Col md={2} className="text-left pt-2 border-right">
                                        <Link to={{ pathname: '/company/' + client.clientId }}>{client.name}</Link>
                                    </Col>
                                    {client.workflows != null && <Col md={10} className="text-left">
                                        {client.workflows != null && client.workflows.map((workflow, workflowIndex) => (
                                            <Fragment key={workflowIndex}>
                                                <Row className={workflowIndex > 0 ? 'border-top pt-3 pb-1 font-weight-bold' : 'py-1 font-weight-bold'}>
                                                    <Col md={4}>
                                                        {workflow.name}
                                                    </Col>
                                                    <Col md={8} className="text-center">
                                                        {workflow.timeTracking != null && workflow.timeTracking.map((tt, ttIndex) => (
                                                            <Row key={ttIndex}>
                                                                <Col md={8}>
                                                                    <Form inline className="justify-content-center">
                                                                        <FormGroup>
                                                                            <Input
                                                                                type="time"
                                                                                onChange={(e) => this.onChange({
                                                                                    clientId: client.clientId,
                                                                                    workflowId: workflow.id,
                                                                                    clientTaskId: null,
                                                                                    clientTaskTimeTrackingId: tt.clientTaskTimeTrackingId,
                                                                                    beginTimestamp: e.target.value,
                                                                                    endTimestamp: tt.endTimestamp
                                                                                })}
                                                                                value={tt.beginTimestamp != null && tt.beginTimestamp !== "" ? tt.beginTimestamp : this.getTZtime()}
                                                                            />
                                                                        </FormGroup>
                                                                        <span className="mx-2">-</span>
                                                                        <FormGroup>
                                                                            <Input
                                                                                type="time"
                                                                                onChange={(e) => this.onChange({
                                                                                    clientId: client.clientId,
                                                                                    workflowId: workflow.id,
                                                                                    clientTaskId: null,
                                                                                    clientTaskTimeTrackingId: tt.clientTaskTimeTrackingId,
                                                                                    beginTimestamp: tt.beginTimestamp,
                                                                                    endTimestamp: e.target.value
                                                                                })}
                                                                                disabled={tt.endTimestamp == null || tt.endTimestamp === "" || tt.beginTimestamp == null || tt.beginTimestamp === ''}
                                                                                value={tt.endTimestamp != null && tt.endTimestamp !== "" ? tt.endTimestamp : ""}
                                                                            />
                                                                        </FormGroup>
                                                                    </Form>
                                                                </Col>
                                                                <Col md={4} className="text-left">
                                                                    <Form inline>
                                                                        {tt.endTimestamp === "" &&
                                                                            <FormGroup>
                                                                                <Button
                                                                                    color="warning"
                                                                                    className="ml-1"
                                                                                    title="Stop Workflow Time Entry"
                                                                                    disabled={this.state.activeButton === 'end_0_' + client.clientId + '_' + workflow.id + '_0'}
                                                                                    onClick={() => this.onEnd({
                                                                                        id: tt.clientTaskTimeTrackingId,
                                                                                        clientId: client.clientId,
                                                                                        workflowId: workflow.id,
                                                                                        clientTaskId: 0,
                                                                                        beginTimestamp: tt.beginTimestamp
                                                                                    })}
                                                                                >
                                                                                    <FontAwesomeIcon icon={this.state.activeButton === 'end_0_' + client.clientId + '_' + workflow.id + '_0' ? faEllipsisH : faStop} />
                                                                                </Button>
                                                                            </FormGroup>
                                                                        }
                                                                        {tt.beginTimestamp !== "" && tt.endTimestamp !== "" && ttIndex === workflow.timeTracking.length - 1 && !tt.isComplete &&
                                                                            <FormGroup>
                                                                                <Button
                                                                                    color="success"
                                                                                    className="ml-1"
                                                                                    title="Add to Workflow Time Entry"
                                                                                    disabled={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_0'}
                                                                                    onClick={() => this.onStart({
                                                                                        clientId: client.clientId,
                                                                                        workflowId: workflow.id,
                                                                                        clientTaskId: 0,
                                                                                    })}
                                                                                >
                                                                                    <FontAwesomeIcon icon={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_0' ? faEllipsisH : faPlus} />
                                                                                </Button>
                                                                            </FormGroup>
                                                                        }
                                                                        {tt.beginTimestamp !== "" && tt.endTimestamp !== "" && ttIndex === workflow.timeTracking.length - 1 && !tt.isComplete &&
                                                                            <FormGroup>
                                                                                <Button
                                                                                    color="primary"
                                                                                    className='ml-1'
                                                                                    title="Mark as Complete"
                                                                                    onClick={() => this.onComplete(tt.clientTaskTimeTrackingId)}
                                                                                    disabled={this.state.activeButton === 'complete_' + tt.clientTaskTimeTrackingId}
                                                                                >
                                                                                    <FontAwesomeIcon icon={faCheck} />
                                                                                </Button>
                                                                            </FormGroup>
                                                                        }
                                                                        {/* <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} allowedPermission="Delete Task Time Entry"> */}
                                                                        <FormGroup>
                                                                            <ConfirmButton
                                                                                color="danger"
                                                                                className="ml-1"
                                                                                title="Delete Time Entry"
                                                                                onClick={() => this.onDelete(tt.clientTaskTimeTrackingId)}
                                                                                disabled={this.state.activeButton === 'delete_' + tt.clientTaskTimeTrackingId}
                                                                            >
                                                                                <FontAwesomeIcon icon={this.state.activeButton === 'delete_' + tt.id ? faEllipsisH : faTrashAlt} />
                                                                            </ConfirmButton>
                                                                        </FormGroup>
                                                                        {/* </PermissionWrapper> */}
                                                                        {tt.isComplete && <FontAwesomeIcon className='ml-3 text-success' icon={faCheck} />}
                                                                    </Form>
                                                                </Col>
                                                            </Row>
                                                        ))
                                                        }
                                                        {workflow.timeTracking == null &&
                                                            <Row>
                                                                <Col md={8} className="text-center">
                                                                    <Form inline className="justify-content-center">
                                                                        <FormGroup>
                                                                            <Input
                                                                                type="time"
                                                                                disabled={true}
                                                                            />
                                                                        </FormGroup>
                                                                        <span className="mx-2">-</span>
                                                                        <FormGroup>
                                                                            <Input
                                                                                type="time"
                                                                                disabled={true}
                                                                            />
                                                                        </FormGroup>
                                                                    </Form>
                                                                </Col>
                                                                <Col md={4}>
                                                                    <Form inline>
                                                                        <FormGroup>
                                                                            <Button
                                                                                color="success"
                                                                                className="ml-1"
                                                                                title="Start Workflow Time Entry"
                                                                                disabled={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_0'}
                                                                                onClick={() => this.onStart({
                                                                                    clientId: client.clientId,
                                                                                    workflowId: workflow.id,
                                                                                    clientTaskId: 0,
                                                                                })}
                                                                            >
                                                                                <FontAwesomeIcon icon={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_0' ? faEllipsisH : faPlay} />
                                                                            </Button>
                                                                        </FormGroup>
                                                                    </Form>
                                                                </Col>
                                                            </Row>}
                                                    </Col>
                                                </Row>
                                                {workflow.tasks != null && workflow.tasks.filter(task => task.id != null).map((task, taskIndex) => (
                                                    <Row key={taskIndex} className='border-top py-1'>
                                                        <Col md={4}>
                                                            <span className='pl-3'>{task.name}</span>
                                                        </Col>
                                                        <Col md={8} className="text-center">
                                                            {task.timeTracking != null && task.timeTracking.map((tt, ttIndex) => (
                                                                <Row key={ttIndex}>
                                                                    <Col md={8}>
                                                                        <Form inline className="justify-content-center">
                                                                            <FormGroup>
                                                                                <Input
                                                                                    type="time"
                                                                                    onChange={(e) => this.onChange({
                                                                                        clientId: client.clientId,
                                                                                        workflowId: workflow.id,
                                                                                        clientTaskId: task.id,
                                                                                        clientTaskTimeTrackingId: tt.clientTaskTimeTrackingId,
                                                                                        beginTimestamp: e.target.value,
                                                                                        endTimestamp: tt.endTimestamp
                                                                                    })}
                                                                                    value={tt.beginTimestamp != null && tt.beginTimestamp !== "" ? tt.beginTimestamp : this.getTZtime()}
                                                                                />
                                                                            </FormGroup>
                                                                            <span className="mx-2">-</span>
                                                                            <FormGroup>
                                                                                <Input
                                                                                    type="time"
                                                                                    onChange={(e) => this.onChange({
                                                                                        clientId: client.clientId,
                                                                                        workflowId: workflow.id,
                                                                                        clientTaskId: task.id,
                                                                                        clientTaskTimeTrackingId: tt.clientTaskTimeTrackingId,
                                                                                        beginTimestamp: tt.beginTimestamp,
                                                                                        endTimestamp: e.target.value
                                                                                    })}
                                                                                    disabled={tt.endTimestamp == null || tt.endTimestamp === "" || tt.beginTimestamp == null || tt.beginTimestamp === ''}
                                                                                    value={tt.endTimestamp != null && tt.endTimestamp !== "" ? tt.endTimestamp : ""}
                                                                                />
                                                                            </FormGroup>
                                                                        </Form>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Form inline>
                                                                            {tt.endTimestamp === "" &&
                                                                                <FormGroup>
                                                                                    <Button
                                                                                        color="warning"
                                                                                        className="ml-1"
                                                                                        title="Stop Task Time Entry"
                                                                                        disabled={this.state.activeButton === 'end_0_' + client.clientId + '_' + workflow.id + '_' + task.id}
                                                                                        onClick={() => this.onEnd({
                                                                                            id: tt.clientTaskTimeTrackingId,
                                                                                            clientId: client.clientId,
                                                                                            workflowId: workflow.id,
                                                                                            clientTaskId: task.id,
                                                                                            beginTimestamp: tt.beginTimestamp
                                                                                        })}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={this.state.activeButton === 'end_0_' + client.clientId + '_' + workflow.id + '_' + task.id ? faEllipsisH : faStop} />
                                                                                    </Button>
                                                                                </FormGroup>
                                                                            }
                                                                            {tt.beginTimestamp !== "" && tt.endTimestamp !== "" && ttIndex === task.timeTracking.length - 1 && !tt.isComplete &&
                                                                                <FormGroup>
                                                                                    <Button
                                                                                        color="success"
                                                                                        className="ml-1"
                                                                                        title="Add to Task Time Entry"
                                                                                        disabled={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_' + task.id}
                                                                                        onClick={() => this.onStart({
                                                                                            clientId: client.clientId,
                                                                                            workflowId: workflow.id,
                                                                                            clientTaskId: task.id,
                                                                                        })}
                                                                                    >
                                                                                        <FontAwesomeIcon icon={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_' + task.id ? faEllipsisH : faPlus} />
                                                                                    </Button>
                                                                                </FormGroup>
                                                                            }
                                                                                {tt.beginTimestamp !== "" && tt.endTimestamp !== "" && ttIndex === task.timeTracking.length - 1 && !tt.isComplete &&
                                                                                    <FormGroup>
                                                                                        <Button
                                                                                            color="primary"
                                                                                            className='ml-1'
                                                                                            title="Mark as Complete"
                                                                                            onClick={() => this.onComplete(tt.clientTaskTimeTrackingId)}
                                                                                            disabled={this.state.activeButton === 'complete_' + tt.clientTaskTimeTrackingId}
                                                                                        >
                                                                                            <FontAwesomeIcon icon={faCheck} />
                                                                                        </Button>
                                                                                    </FormGroup>
                                                                                }
                                                                            {/* <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} allowedPermission="Delete Task Time Entry"> */}
                                                                            <FormGroup>
                                                                                <ConfirmButton
                                                                                    className="ml-1"
                                                                                    color="danger"
                                                                                    title="Delete Time Entry"
                                                                                    onClick={() => this.onDelete(tt.clientTaskTimeTrackingId)}
                                                                                    disabled={this.state.activeButton === 'delete_' + tt.clientTaskTimeTrackingId}
                                                                                >
                                                                                    <FontAwesomeIcon icon={this.state.activeButton === 'delete_' + tt.id ? faEllipsisH : faTrashAlt} />
                                                                                </ConfirmButton>
                                                                            </FormGroup>
                                                                            {/* </PermissionWrapper> */}
                                                                            {tt.isComplete && <FontAwesomeIcon className='ml-3 text-success' icon={faCheck} />}
                                                                        </Form>
                                                                    </Col>
                                                                </Row>
                                                            ))}
                                                            {task.timeTracking == null &&
                                                                <Row>
                                                                    <Col md={8} className="text-center">
                                                                        <Form inline className="justify-content-center">
                                                                            <FormGroup>
                                                                                <Input
                                                                                    type="time"
                                                                                    disabled={true}
                                                                                />
                                                                            </FormGroup>
                                                                            <span className="mx-2">-</span>
                                                                            <FormGroup>
                                                                                <Input
                                                                                    type="time"
                                                                                    disabled={true}
                                                                                />
                                                                            </FormGroup>
                                                                        </Form>
                                                                    </Col>
                                                                    <Col md={4}>
                                                                        <Form inline>
                                                                            <FormGroup>
                                                                                <Button
                                                                                    color="success"
                                                                                    className="ml-1"
                                                                                    title="Start Task Time Entry"
                                                                                    disabled={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_' + task.id}
                                                                                    onClick={() => this.onStart({
                                                                                        clientId: client.clientId,
                                                                                        workflowId: workflow.id,
                                                                                        clientTaskId: task.id,
                                                                                    })}
                                                                                >
                                                                                    <FontAwesomeIcon icon={this.state.activeButton === 'start_0_' + client.clientId + '_' + workflow.id + '_' + task.id ? faEllipsisH : faPlay} />
                                                                                </Button>
                                                                            </FormGroup>
                                                                        </Form>
                                                                    </Col>
                                                                </Row>}
                                                        </Col>
                                                    </Row>

                                                ))}
                                            </Fragment>
                                        ))}

                                    </Col>}
                                </Row>
                            ))}
                        </Container>
                    </CollapseCard>
                </Col>
            </Row>
        );

    }
}

export default Widget;
